import React, { useContext, useEffect } from "react";
import { getMultiQuoteResultAPI } from "../../api/endpoints/ApiQuotes";
import useErrorLogger from "../../../common/hooks/useErrorLogger";
import { QuoteGroupContext } from "../../providers/RootContextProvider";

const QuoteLoaderWrapper: React.FC = ({ children }) => {
    const { selectors, actions } = useContext(QuoteGroupContext);
    const { Log } = useErrorLogger();

    const groupId = selectors.getGroupId();
    const isValidQuoteResult = selectors.isQuoteResultValid();

    useEffect(() => {
        if (!isValidQuoteResult && !selectors.isLoadingQuoteResult()) {
            actions.setIsLoadingQuoteResults(true);
            getMultiQuoteResultAPI(groupId, selectors.getPaymentFrequency())
                .then((cards) => {
                    actions.setQuoteResults(cards);
                })
                .catch((e) => {
                    Log(e, {
                        source: "Multi-product-page--get-results"
                    });
                })
                .finally(() => {
                    actions.setIsLoadingQuoteResults(false);
                });
        }
    }, [isValidQuoteResult]);

    return <React.Fragment>{children}</React.Fragment>;
};

export default QuoteLoaderWrapper;
